import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Observable, debounceTime, distinctUntilChanged, of, startWith, switchMap } from "rxjs";
import { IDetailItem, getEmptyDetailItem } from "../detail-item/detail-item.interface"
import { AuthService } from "../../services/auth.service";
import { ProductsService } from "../../../admin/products-page/products/products.service";
import { AlertService } from "../../services/alert.service";

@Component({
  selector: 'app-detail-list',
  templateUrl: './detail-list.component.html',
  styleUrls: ['./detail-list.component.css']
})
export class DetailListComponent implements OnInit {

  @Input('header') header = true;
  @Input('footer') footer = true;
  @Input('disableButton') disableButton = true;
  @Input('readOnly') readOnly = false;
  @Input('pricing') pricing = true;
  @Input('items') items!: any;
  @Input('taxPercentage') taxPercentage: number = 0;
  @Output('listChange') listChange = new EventEmitter<any>();
  form!: UntypedFormGroup;
  totals = { total: 0, subtotal: 0, tax: 0, costsubtotal: 0 };
  openDetails: any = [];
  curr!: string;
  loading = true;


  emptyItem = getEmptyDetailItem();

  constructor(
    private _AuthService: AuthService,
    private _ProductsService: ProductsService,
    private fb: UntypedFormBuilder,
    private _AlertService: AlertService,
    private cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.initializeComponent();
  }

  initializeComponent() {
    const items: any = this.items;
    this.curr = this._AuthService.currency();
    if (!(items?.length > 0)) throw new Error('Item list not initialized');
    items.forEach((item: any) => {
      item.taxPercentage = item.taxPercentage ?? this.taxPercentage ?? this.emptyItem.taxPercentage
      this.openDetails.push(false);
    });
    items.length <= 1 ? this.disableButton = true : this.disableButton = false;
    this.calculateTotals();
    this.loading = false;
  }

  addItem() {
    const items: any = this.items;
    if (items.length > 0) {
      const lastItem = items[items.length - 1];
      if (lastItem.detail === "")
        return this._AlertService.warn("Para añadir una nueva línea, por favor complete la anterior");
    }
    items.push(getEmptyDetailItem())
    this.calculateTotals();
  }

  onItemChange(item: any, event: any) {
    const items: any = this.items;
    // console.log(event);
    items.forEach((el: any) => {
      try { el.tax = parseFloat(el.tax as any) } catch (e) { }
      try { el.subtotal = parseFloat(el.subtotal as any) } catch (e) { }
      try { el.costsubtotal = parseFloat(el.costsubtotal as any) } catch (e) { }
    })
    items.length <= 1 ? this.disableButton = true : this.disableButton = false;
    this.calculateTotals();
  }

  onRemove(item: any) {
    const items: any = this.items;
    const index = items.indexOf(item);
    items.splice(index, 1);
    items.length <= 1 ? this.disableButton = true : this.disableButton = false;
    this.calculateTotals();
  }

  calculateTotals() {
    // console.log(this.items);
    const items: any = this.items;
    try { this.totals.costsubtotal = items.reduce((acc: any, el: any) => acc + (+(el.costsubtotal ?? 0)), 0) } catch (e) { this.totals.costsubtotal = 0 }
    try { this.totals.subtotal = items.reduce((acc: any, el: any) => acc + (+(el.subtotal ?? 0)), 0) } catch (e) { this.totals.subtotal = 0 }
    try { this.totals.tax = items.reduce((acc: any, el: any) => acc + (+(el.tax ?? 0)), 0) } catch (e) { this.totals.tax = 0 }
    this.totals.total = this.totals.subtotal + this.totals.tax;
    let data = { items: this.items, totals: this.totals }
    this.listChange.emit(data);
  }
}